<template>
<div class="login-body">

<div class="container login-NC-Pro">
<div class="row">
<div class="col-lg-12 ml-auto mr-auto">
<img src="@/assets/images/logo-NC-Core.png" alt="NC Core"/>
</div>
</div>

<slot />

</div>
</div>

</template>
<script>
import '@/assets/css/material-components-web.min.css'
import '@/assets/css/icon.css'
import '@/assets/css/fonts.css'
import '@/assets/css/bootstrap.min.css'
export default {
	name: 'Default'
}
</script>



// WEBPACK FOOTER //
// src/components/Default.vue